import VoMaterialTheme2 from "@vocollege/theme";
import { Font } from "@react-pdf/renderer";

import Lato from "../fonts/lato-regular.ttf";
import LatoItalic from "../fonts/lato-italic.ttf";
import Lato100 from "../fonts/lato-100.ttf";
import Lato100italic from "../fonts/lato-100italic.ttf";
import Lato300 from "../fonts/lato-300.ttf";
import Lato300italic from "../fonts/lato-300italic.ttf";
import Lato700 from "../fonts/lato-700.ttf";
import Lato700italic from "../fonts/lato-700italic.ttf";
import Lato900 from "../fonts/lato-900.ttf";
import Lato900italic from "../fonts/lato-900italic.ttf";

import EBGaramond500 from "../fonts/eb-garamond-v15-latin-500.ttf";
import EBGaramond500italic from "../fonts/eb-garamond-v15-latin-500italic.ttf";
import EBGaramond600 from "../fonts/eb-garamond-v15-latin-600.ttf";
import EBGaramond600italic from "../fonts/eb-garamond-v15-latin-600italic.ttf";
import EBGaramond700 from "../fonts/eb-garamond-v15-latin-700.ttf";
import EBGaramond700italic from "../fonts/eb-garamond-v15-latin-700italic.ttf";
import EBGaramond800 from "../fonts/eb-garamond-v15-latin-800.ttf";
import EBGaramond800italic from "../fonts/eb-garamond-v15-latin-800italic.ttf";
import EBGaramond from "../fonts/eb-garamond-v15-latin-regular.ttf";
import EBGaramonditalic from "../fonts/eb-garamond-v15-latin-italic.ttf";

import Arial from "../fonts/arial.ttf";
import ArialItalic from "../fonts/arial-italic.ttf";
import ArialBold from "../fonts/arial-bold.ttf";
import ArialBoldItalic from "../fonts/arial-bold-italic.ttf";

import LucidaGrande from "../fonts/lucida-grande.ttf";
import LucidaGrandeBold from "../fonts/lucida-grande-bold.ttf";

// Override some options on the default theme.
// @TODO Is there a better way to override?
// VoMaterialTheme2.palette.background.default = "#fafafa";
// VoMaterialTheme2.shape.borderRadius = 8;

export default VoMaterialTheme2;

Font.register({
  family: "Lato",
  fonts: [
    { src: Lato },
    { src: LatoItalic, fontStyle: "italic" },
    { src: Lato100, fontWeight: 100 },
    { src: Lato100italic, fontWeight: 100, fontStyle: "italic" },
    { src: Lato300, fontWeight: 300 },
    { src: Lato300italic, fontWeight: 300, fontStyle: "italic" },
    { src: Lato700, fontWeight: 700 },
    { src: Lato700italic, fontWeight: 700, fontStyle: "italic" },
    { src: Lato900, fontWeight: 900 },
    { src: Lato900italic, fontWeight: 900, fontStyle: "italic" },
  ],
});

Font.register({
  family: "EB Garamond",
  fonts: [
    { src: EBGaramond },
    { src: EBGaramonditalic, fontStyle: "italic" },
    { src: EBGaramond500, fontWeight: 500 },
    { src: EBGaramond500italic, fontStyle: "italic" },
    { src: EBGaramond600, fontWeight: 600 },
    { src: EBGaramond600italic, fontWeight: 600, fontStyle: "italic" },
    { src: EBGaramond700, fontWeight: 700 },
    { src: EBGaramond700italic, fontWeight: 700, fontStyle: "italic" },
    { src: EBGaramond800, fontWeight: 800 },
    { src: EBGaramond800italic, fontWeight: 800, fontStyle: "italic" },
  ],
});

Font.register({
  family: "Arial",
  fonts: [
    { src: Arial },
    { src: ArialItalic, fontStyle: "italic" },
    { src: ArialBold, fontWeight: 600 },
    { src: ArialBoldItalic, fontWeight: 600, fontStyle: "italic" },
  ],
});

Font.register({
  family: "Lucida Grande",
  fonts: [{ src: LucidaGrande }, { src: LucidaGrandeBold, fontWeight: 600 }],
});

Font.registerHyphenationCallback((word) => [word]);
